import React from "react";
import Slider from "react-slick";
import Navbar from "../../../layout/Navbar";
import Footer from "../../../layout/Footer";
import HighAluminaImage from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/80-BRICKS-1.jpeg";
import dataSheetImg from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/data-high-alumina.png";
import Slider1 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/40-BRICKS.jpeg";
import Slider2 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/50-BRICKS-1.jpeg";
import Slider3 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/50-BRICKS-2.jpeg";
import Slider4 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/60-BRICKS-1.jpeg";
import Slider5 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/60-BRICKS-2.jpeg";
import Slider6 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/70-BRICKS-1.jpeg";
import Slider7 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/80-BRICKS-1.jpeg";
import Slider8 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/80-BRICKS-2.jpeg";
import Slider9 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/80-BRICKS-3.jpeg";
import Slider10 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/FIRE-TILES.jpeg";
import Slider11 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/SPECIAL-BURNER-BLOCK.jpeg";
import Slider12 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/img1.jpeg";
import Slider13 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/img2.jpeg";
import Slider14 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/img3.jpeg";
import Slider15 from "../../../assets/Our Products/Refractory Bricks/High Alumina Bricks/img4.jpeg";


const High_Alumina_Bricks = () => {

  const sliderImages = [
    Slider1, Slider2, Slider3, Slider4, Slider5, Slider6, Slider7, Slider8, Slider9, Slider10, Slider11, Slider12, Slider13, Slider14, Slider15
  ];

  // Responsive slider settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* About Fire Clay Bricks Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-600">High Alumina Bricks</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              JANTA Group is one of the largest manufacturer and supplier of High Alumina Bricks which are widely used in various industries for various purposes.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              These High Alumina Fire Bricks are manufactured from high-grade raw materials, which are procured from trusted and reliable vendors across the world. Our clients can avail this comprehensive variety of High Alumina Fire Bricks at market leading prices.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              Our High Alumina bricks are widely used in the construction of furnaces, kilns, fireplaces and fireboxes for they can withstand high temperatures and are suitable for fire places in the factory and other commercial building.
            </p>
          </div>

          {/* Image Section */}
          <div className="flex justify-center md:justify-end relative">
            <img
              src={HighAluminaImage}
              alt="High Alumina Bricks"
              className="w-80 h-80 object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* Data Sheet Section */}
      <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-10">
            Product Data Sheet for <span className="text-orange-500">High Alumina Bricks</span>
          </h2>

          <div className="flex justify-center">
            <img
              src={dataSheetImg}
              alt="High Alumina Bricks Data Sheet"
              className="rounded-1xl shadow-2xl border border-white/20 w-full sm:w-[80%] md:w-[70%] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Area of Application Section */}
      <section className="py-16 bg-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Area Of Application
          </h2>
          <ul className="list-disc list-inside text-lg text-gray-700 space-y-2">
            <li>Steel Industries</li>
            <li>Cement Rotary Kilns</li>
            <li>Lime Industries</li>
            <li>Glass industries</li>
            <li>Blast furnaces</li>
            <li>Electric Furnace</li>
          </ul>
        </div>
      </section>

      {/* Auto Image Slider Section */}
      <section className="py-8 sm:py-16 bg-[#0b032d] text-white relative overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="relative flex justify-center overflow-hidden rounded-2xl">

            <div className="slider w-full sm:w-2/3 h-[260px] sm:h-[250px]">
              <div className="w-full">
                <Slider {...sliderSettings}>
                  {sliderImages.map((image, index) => (
                    <div key={index} className="px-2 sm:px-2">
                      <img
                        src={image}
                        alt={`Slide ${index + 1}`}
                        className="h-[260px] sm:h-[200px] lg:h-[250px] w-full object-contain rounded-lg shadow-md"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>

          </div>
        </div>
      </section>


      <style jsx>{`
        @keyframes slide {
          0% { transform: translateX(0); }
          33% { transform: translateX(-260px); }
          66% { transform: translateX(-520px); }
          100% { transform: translateX(0); }
        }
        .animate-slide {
          animation: slide 8s infinite linear;
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default High_Alumina_Bricks;
